/**
 * @desc Export Pie Chart Resolution configuration.
 * @example
 * import { ColorConfig } from 'config/piechart-configs/resolution-config';
 */

export const ColorConfig = [
	'#A87170',
	'#AB5757',
	'#9F5176',
	'#9A70A4',
	'#876CA2',
	'#817BA5',
	'#657093',
	'#69819C',
	'#7F97A7',
	'#6B8D9B',
	'#6B9698',
	'#4F8F7A',
	'#61956E',
	'#71A761',
	'#92AB7E',
	'#93A133',
	'#A79F31',
	'#A4895C',
    '#A4775F',
    
    // '#E19BF3',
    // '#C295F0',
    // '#817BA5',
    // '#657093',
    // '#6A819C',
    // '#7E97A6',
    // '#6B8D9A',
    // '#6A9698'
];

export const ColorConfigInActive = [
    '#f99d9d',
    '#ff7272',
    '#ea68a6',
    '#e29af3',
    '#c294f0',
    '#b9aef4',
    '#8b9cd6',
    '#91b9e6',
    '#b3ddf7',
    '#94cce4',
    '#93dcdf',
    '#65d0ac',
    '#84d998',
    '#9ef983',
    '#d3ffb4',
    '#d8ed38',
    '#f8eb33',
    '#f2c67b',
    '#f3a87f',

    // '#9A70A4',
    // '#876BA1',
    // '#B9AEF4',
    // '#8B9CD5',
    // '#92B9E6',
    // '#B3DEF6',
    // '#95CCE3',
    // '#93DCDF'
];
